<template>
  <v-container fluid class="">
    <h3 class='ml-2 mb-3'><v-icon medium class='mr-2' color='black'>$vuetify.icons.amaze-users</v-icon>User Management</h3>
    <div class="actionsPanel">
      <div class="dialogButtons">
        <v-dialog
          v-model="dialog"
          max-width="500px"
          @keydown.esc="dialog=false"
          persistent
        >
          <v-btn
            slot="activator"
            color="primary"
            class="mb-4 ml-0"
            @click="addItem()"
          >
            <v-icon
              small
              class="mr-1">fa-plus</v-icon>
            Add New User
          </v-btn>
          <v-card>
            <v-card-title>
              <h3 class="headline">{{ formTitle }}</h3>
            </v-card-title>
            <hr class="thick" >

            <v-card-text>
              <v-layout wrap>
                <p v-if="formTitle === 'New User'">Enter the new user information below. They will receive a notification email containing their login information and temporary password.</p>
                <v-form
                  ref="userForm"
                  v-model="form.valid"
                  style="width:100%">
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.first_name"
                      :rules="form.first_name"
                      label="First Name*"/>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.last_name"
                      :rules="form.last_name"
                      label="Last Name*"/>
                  </v-flex>
                  <v-flex xs12 v-if="isExistingUser">
                    <v-text-field
                      v-model="editedItem.display_name"
                      :rules="form.display_name"
                      label="Display Name*"/>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.email"
                      :rules="form.email"
                      label="Email*"/>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="editedItem.state_id"
                      :items="states"
                      :rules="form.state_id"
                      item-text="name"
                      item-value="id"
                      label="State*"
                    ></v-select>
                  </v-flex>
                   <v-flex xs12>
                    <v-select
                      v-model="editedItem.organization_id"
                      :items="organizations"
                      :rules="form.organization_id"
                      item-text="name"
                      item-value="id"
                      label="Organization*"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="flags"
                      v-model="editedItem.flags"
                      label="User Flags"
                      class="mb-0"
                      item-text="friendly_name"
                      item-value="id"
                      multiple
                      chips
                      hide-selected
                      :search-input.sync="flag_search"
                      @change="flag_search = ''"
  no-data-text="Start typing to search flags">
                      <template
                        slot="selection"
                        slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          :key="JSON.stringify(data.item)"
                          close
                          class="chip--select-multi"
                          @input="data.parent.selectItem(data.item)">
                          {{ data.item.friendly_name }}
                        </v-chip>
                      </template>
                      <template
                        slot="item"
                        slot-scope="data">
                        <template>
                          <v-list-tile-content>
                            <v-list-tile-title v-html="data.item.friendly_name"/>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-form>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                @click.native="close" flat outline>Cancel</v-btn>
              <v-btn
                color="primary"
                @click.native="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="bulkDialog"
          max-width="500px"
          @keydown.esc="bulkDialog=false"
          persistent
        >
          <v-btn
            slot="activator"
            flat
            outlined
            outline
            class="mb-4 ml-2">
            Add Users in Bulk
          </v-btn>
          <v-card>
            <v-card-title>
              <h3 class="">Bulk Add Users</h3>
            </v-card-title>

            <v-card
              class="pl-3"
              flat>
              <v-layout>
                <v-btn
                  :href="templateUrl"
                  small
                  color="gray">
                  <v-icon
                    small
                    class="mr-1">get_app</v-icon>
                  1. Download Excel Template and Populate
                </v-btn>
              </v-layout>
              <v-form
                ref="bulkUserForm"
                v-model="bulkForm.valid"
                style="width:100%">

                <v-layout>
                  <v-flex xs12>
                      <v-select
                        v-model="bulk_state"
                        :items="states"
                        :rules="bulkForm.bulk_state"
                        item-text="name"
                        item-value="id"
                        class="mt-4 mr-4 ml-3"
                        label="2a. Select State for New Account*"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <v-select
                        v-model="bulk_organization"
                        :items="organizations"
                        :rules="bulkForm.bulk_organization"
                        item-text="name"
                        item-value="id"
                        class="mr-4 ml-3"
                        label="2b. Select Organization for New Accounts*"
                      ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <v-autocomplete
                      @change="group_search = ''"
                      :items="group_ac_results"
                      v-model="bulk_groups"
                      :loading="group_ac_loading"
                      :search-input.sync="group_search"
                      label="2c. Select Initial Group(s) for New Accounts (optional)"
                      class="mb-4 mr-4 ml-3"
                      item-text="name"
                      item-value="id"
                      item-avatar="group_photo.avatar"
    multiple chips cache-items hide-selected no-data-text="Start typing to search and select groups">
                      <template
                        slot="selection"
                        slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          :key="JSON.stringify(data.item)"
                          close
                          class="chip--select-multi"
                          @input="data.parent.selectItem(data.item)">
                          {{ data.item.name }}
                        </v-chip>
                      </template>
                      <template
                        slot="item"
                        slot-scope="data">
                        <template>
                          <v-list-tile-content>
                            <v-list-tile-title v-html="data.item.name"/>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <AmazePhotoUpload
                    :btn-trigger="true"
                    label="3. Upload Populated Excel to Add Users"
                    icon="person_add"
                    field-name="new_users"
                    accept="xlsx"
                    large
                    :disabled="bulkFileUploading"
                    @formData="onBulkFileChange" />
                    <v-progress-circular class="mt-2" indeterminate color="primary" v-if="bulkFileUploading"></v-progress-circular>
                </v-layout>
                <v-layout>
                  <v-flex v-if="bulkErrors">
                    <div class="mr-2 ml-2">
                      <div>
                        <br/>
                        <div>
                          <h3 class="text-warning" ref="bulkUserErrors">Errors Detected</h3>
                        </div>
                        <div>
                          <p>There were some issues with the imported user data and not all users were added to Amaze. Please correct the following issues and re-upload the rows that were skipped.</p>
                          </div>
                      </div>
                      <div>
                        <v-data-table :headers="bulkErrorHeaders" :items="bulkErrors" :items-per-page="5" class="elevation-1">
                          <template v-slot:items="props">
                            <td>{{ props.item.row }}</td>
                            <td><span v-for="(value, key) in props.item.errors" v-bind:key="key">{{ value[0] }}</span> </td>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                @click.native="closeBulk" flat outline>Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div class="filterControls mt-0">
        <v-layout row justify-end>
          <v-flex xs12 d-flex justify-end>
              <v-text-field class="mt-0 appendIcon" v-model="usersFilter" placeholder="Enter keyword to filter users" append-icon="fa-search" clearable>
              </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row justify-end>
          <v-flex xs12 d-flex justify-end>
            <v-select :items="flags" v-model="selectedFlag"  item-text="friendly_name" item-value="id" clearable>
              <template slot="label">
                Role<span class='star'></span>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="users"
        :pagination.sync="pagination"
        :total-items="totalUsers"
        :loading="usersLoading"
        :rows-per-page-items="rowsPerPage"
        sort-icon="arrow_drop_down"
        class="elevation-1 amaze-data-table">
        <template
          slot="items"
          slot-scope="props">
          <td class="larger"><div class="no-break"><AmazeAvatar :user="props.item" :key="props.item.id" size="22px" hideTip="true" class="mr-2"></AmazeAvatar> {{ props.item.first_name }}</div></td>
          <td class="larger">{{ props.item.last_name }}</td>
          <td>{{ props.item.email }}</td>
          <td><span v-if="props.item.organization && props.item.organization.name">{{ props.item.organization.name }}</span></td>
          <td>
            <v-chip
              v-for="(flag) in props.item.flags"
              :key="flag.pivot.id"
              label
              disabled
              class="flag"
              v-bind:class="`flag_`+flag.name">
              {{ flag.friendly_name }}
            </v-chip>
          </td>
          <td class="text-right layout px-0 cardActions">

            <v-menu class='cardMenu hidden-md-and-up' bottom left >
            <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
            <v-list>
              <div>
                <v-list-tile v-on:click="impersonateUser(props.item.id)">
                  <v-list-tile-title>Impersonate User</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-on:click="editItem(props.item)">
                  <v-list-tile-title>Edit User</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-on:click="deleteItem(props.item)">
                  <v-list-tile-title>Delete User</v-list-tile-title>
                </v-list-tile>
              </div>
            </v-list>
          </v-menu>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn class="hidden-sm-and-down amaze-user-action" :disabled="isUberAdmin(props.item)" v-bind:class="{disabled : isUberAdmin(props.item)}" slot="activator" @click="impersonateUser(props.item.id)" icon><v-icon>$vuetify.icons.amaze-user</v-icon></v-btn>
              </div>
            </template>
            <span v-if="isUberAdmin(props.item)">You cannot impersonate an uber admin</span><span v-else>Impersonate user</span>
          </v-tooltip>
           <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn class="hidden-sm-and-down amaze-user-action" slot="activator" @click="editItem(props.item)" icon><v-icon>$vuetify.icons.amaze-edit</v-icon></v-btn>
              </div>
            </template>
            <span>Edit user</span>
          </v-tooltip>
           <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn class="hidden-sm-and-down amaze-user-action" slot="activator" @click="deleteItem(props.item)" icon><v-icon>$vuetify.icons.amaze-delete</v-icon></v-btn>
              </div>
            </template>
            <span>Delete user</span>
          </v-tooltip>
          </td>
        </template>
        <template slot="no-data">
          <v-btn
            color="primary"
            @click="getUsersFromApi">Reset</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>
<style lang='scss' scoped>
  @import "src/styles/variables.scss";
  .no-break {
    white-space: nowrap;
  }
  .v-chip {
    &.flag {
      color: black;
      padding: 0px;
      margin: 2px;
      height: 24px;
      .v-chip__content {
        opacity: 1;
        padding:0;
        margin:0;
      }
      &.flag_uber_admin {
        background-color: #d6f0f6;
      }
      &.flag_rti_admin {
        background-color: #DEDEDE;
      }
      &.flag_educator {
        background-color: #FEF4D4;
      }
      &.flag_coach {
        background: rgba(0,0,255,0.2);
      }
      &.flag_researcher {
        background: rgba(0,255,0,0.2);
      }
      &.flag_ed_services {
        background-color: #F1EAD2;
      }
      &.flag_event_tracker_admin {
        background-color: #7EEA745C;
      }
    }
  }

  .actionsPanel {
    display: flex;
    flex-wrap: wrap;
  }
  .dialogButtons {
    width: 100%;
    max-width: 375px;
    flex-grow: 1;
  }
  .filterControls {
    min-width: calc(100% - 390px);
    flex-grow: 1;
    display: block;
    div {
      @media (max-width: 300px) {
        display: block !important;
      }

    }
  }
  .filterControls .v-input {
    max-width: 350px;
    min-width: 250px;
    float: right;
  }

  .cardActions {
    button:hover {
      color: $icon-blue;
      svg {
        fill: $icon-blue !important;
        path, text {
          fill: $icon-blue !important;
        }
      }
      * {
        color: $icon-blue;
        fill: $icon-blue;
      }
    }
  }

  button {
    &.amaze-user-action {
      color: rgba(0,0,0,0.87) !important;
      &:hover {
         color: $icon-blue !important;
         svg {
          fill: $icon-blue !important;
          path, text {
            fill: $icon-blue !important;
          }
         }
        * {
          color: $icon-blue;
          fill: $icon-blue;
        }
      }
    }
  }

  @media (max-width: 991px) {
    .dialogButtons {
      width: 100%;
      max-width: 100%;
      flex-grow: 1;
    }
    .filterControls {
      width: 100%;
      max-width: 100%;
      flex-grow: 1;
      display: block;
    }
    .filterControls {
      .v-input,.v-select__selection {
        max-width: 350px;

        float: left;
      }
    }
  }
</style>
<script>
import AmazePhotoUpload from '@/components/Widgets/AmazePhotoUpload'
// import AmazeAvatar from '@/components/Widgets/AmazeAvatar'
import MemberService from '@/services/MemberService'
import AmazeAvatar from "@/components/Widgets/AmazeAvatar";
import _ from 'lodash'

export default {
  components: {
    AmazePhotoUpload,
    AmazeAvatar
  },
  data: () => ({
    dialog: false,
    bulkDialog: false,
    bulkErrors: false,
    bulkErrorHeaders: [
      { text: 'Row', align: 'left', value: 'row' },
      { text: 'Error', align: 'left', value: 'errors' }
    ],
    templateUrl: '/downloads/bulk_users_template.xlsx',
    headers: [
      { text: 'First Name', value: 'first_name' },
      { text: 'Last Name', value: 'last_name' },
      { text: 'Email', value: 'email' },
      { text: 'Organization', value: 'organization.name', sortable: false },
      { text: 'Role', value: null, sortable: false },
      { text: '', value: null, sortable: false, align: 'center' }
    ],
    usersLoading: true,
    bulkFileUploading: false,
    pagination: {
      rowsPerPage: 50
    },
    rowsPerPage: [25, 50, 100],
    totalUsers: 0,
    users: [],
    usersFilter: null,
    selectedFlag: null,
    flags: [],
    states: [],
    organizations: [],
    bulk_groups: [],
    bulk_organization: null,
    bulk_state: null,
    editedIndex: -1,
    editedItem: {
      last_name: '',
      first_name: '',
      email: '',
      state_id: null,
      organization_id: null,
      flags: []
    },
    defaultItem: {
      last_name: '',
      first_name: '',
      email: '',
      state_id: null,
      organization_id: null,
      flags: []
    },
    form: {
      valid: false,
      first_name: [v => !!v || 'Please enter a first name '],
      last_name: [v => !!v || 'Please enter a last name'],
      display_name: [v => !!v || 'Please enter a display name'],
      email: [v => !!v || 'Please enter an email address'],
      state_id: [v => !!v || 'Please choose a state'],
      organization_id: [v => !!v || 'Please choose an organization'],
      flags: [v => !!v || 'Please select a flag']
    },
    bulkForm: {
      valid: false,
      bulk_state: [v => !!v || 'Please choose a state'],
      bulk_organization: [v => !!v || 'Please choose an organization']
    },
    flag_search: null,
    ac_loading: false,
    ac_results: [],
    group_search: null,
    group_ac_results: [],
    group_ac_loading: false
  }),

  computed: {
    userCount() {
      return this.filteredUsers().length;
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New User' : 'Edit User'
    },
    isNewUser() {
      return this.editedIndex === -1;
    },
    isExistingUser() {
      return !this.isNewUser;
    }
  },

  watch: {
    bulkDialog(val) {
      this.bulkErrors = false;
      this.bulk_groups = [];
      this.bulk_organization = null;
      this.bulk_state = null;
    },
    dialog (val) {
      val || this.close()
    },
    usersFilter: _.debounce(function(val) {
      this.getUsers();
    }, 500),
    selectedFlag: _.debounce(function(val) {
      this.getUsers();
    }, 500),
    pagination: {
      handler () {
        this.getUsers()
      },
      deep: true
    },
    group_search (val) {
      val && this.querySelections(val)
    }
  },

  mounted () {
    this.getUsers()

    this.$http.get('flags').then(
      response => {
        this.flags = response.body.data
      },
      response => {
        console.log('Error getting flag options.')
      }
    )

    this.$http.get('states/list').then(
      response => {
        this.states = response.body.data
      },
      response => {
        console.log('Error getting states.')
      }
    )

    this.$http.get('organizations/list').then(
      response => {
        this.organizations = response.body.data
      },
      response => {
        console.log('Error getting organizations.')
      }
    )
  },

  methods: {
    isUberAdmin(user) {
      return user.flags.filter(flag => flag.name === 'uber_admin').length > 0;
    },
    getUsers () {
      this.getUsersFromApi().then(data => {
        this.users = data.items
        this.totalUsers = data.total
      })
    },
    querySelections (v) {
      this.group_ac_loading = true
      setTimeout(() => {
        this.$http.get('groups/autocomplete?q=' + v).then(
          response => {
            this.group_ac_results = response.body
          },
          response => {
            console.log('Error getting users from autocomplete.')
          }
        )
        this.group_ac_loading = false
      }, 300)
    },
    getUsersFromApi () {
      this.usersLoading = true

      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const sortOrder = descending ? 'desc' : 'asc'
        this.$http
          .get(
            'users?page=' + page +
                (rowsPerPage ? '&rowsPerPage=' + rowsPerPage : '') +
                (sortBy ? '&sortBy=' + sortBy : '') +
                (sortOrder ? '&sortOrder=' + sortOrder : '') +
                (this.usersFilter ? '&filterText=' + encodeURIComponent(this.usersFilter) : '') +
                (this.selectedFlag ? '&role=' + encodeURIComponent(this.selectedFlag) : '')
          )
          .then(
            response => {
              var items = response.body.data.data ?? response.body.data;
              var total = response.body.meta.total ?? response.body.total;
              this.usersLoading = false
              resolve({
                items,
                total
              })
            },
            response => {
              console.log('Error getting users.')
              reject(new Error('Error getting users.'))
              this.usersLoading = false
            }
          )
      })
    },
    addItem() {
      this.$refs.userForm.reset();
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      var itemFlags = [];
      this.editedItem.flags = itemFlags;
      this.form.valid = true;
    },
    editItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      var itemFlags = []
      for (var i in this.editedItem.flags) {
        itemFlags.push(this.editedItem.flags[i].id)
      }
      this.editedItem.flags = itemFlags
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.users.indexOf(item)
      const userId = this.users[index].id
      if (confirm('Are you sure you want to delete this user?')) {
        this.$http.delete('users/' + userId).then(
          response => {
            this.users.splice(index, 1)
          },
          response => {
            console.log('Error deleting user.')
          }
        )
      }
    },

    close () {
      this.$refs.userForm.reset();
      this.dialog = false
    },

    onBulkFileChange (formData) {
      if (this.$refs.bulkUserForm.validate()) {
        this.bulkFileUploading = true
        formData.append('groups', this.bulk_groups)
        formData.append('state', this.bulk_state)
        formData.append('organization', this.bulk_organization)

        this.$http.post('users/bulk_add', formData).then(
          response => {
            this.bulkFileUploading = false;
            this.bulkDialog = false;
            this.bulkErrors = false;
            this.$store.commit('updateMessage', {
              message: 'New users created.',
              snackbar: true
            })
            this.getUsers()
            this.closeBulk()
          },
          response => {
            this.bulkFileUploading = false;
            this.bulkErrors = response.body.errors;
            this.$store.commit('updateMessage', {
              message: 'Error creating new users.',
              snackbar: true
            })
            console.log('Error creating new users.')
            // Scroll error messaging into view.
            this.$nextTick(() => {
              if (this.$refs.bulkUserErrors) { this.$refs.bulkUserErrors.scrollIntoView(); }
            })
          }
        )
      } else {
        this.$store.commit('updateMessage', {
          message:
              'Nice try, but some required information is missing. Give it another go!',
          snackbar: true
        })
      }
      //      this.closeBulk()
    },

    closeBulk () {
      this.$refs.bulkUserForm.reset();
      this.bulkDialog = false;
    },

    save () {
      if (this.$refs.userForm.validate()) {
        var newFlags = []
        for (var i in this.editedItem.flags) {
          newFlags.push(this.editedItem.flags[i])
        }
        var formData = {
          first_name: this.editedItem.first_name,
          last_name: this.editedItem.last_name,
          email: this.editedItem.email,
          state_id: this.editedItem.state_id,
          organization_id: this.editedItem.organization_id,
          flags: newFlags
        }
        if (this.editedIndex > -1) {
          // edit existing user
          // get existing user id
          var userId = this.users[this.editedIndex].id;
          formData.id = userId;
          formData.display_name = this.editedItem.display_name;

          this.$http.put('users/' + userId, formData).then(
            response => {
              Object.assign(this.users[this.editedIndex], response.body.data);
              this.editedItem = Object.assign({}, this.defaultItem);
              this.editedIndex = -1;
              this.getUsers();
              this.close();
            },
            response => {
              console.log('Error updating user.', response)
            }
          )
        } else {
          // create new user
          this.$http.post('users/', formData).then(
            response => {
              this.users.push(response.body.data);
              this.getUsers();
              this.close();
            },
            response => {
              console.log('Error saving new user.', response)
            }
          )
        }
      } else {
        this.$store.commit('updateMessage', {
          message:
              'Nice try, but some required information is missing. Give it another go!',
          snackbar: true
        })
      }
    },
    impersonateUser(userId) {
      this.$store.commit("loading", { loading: true });

      MemberService.impersonateUser(userId).then(
        response => {
          this.$auth.token("impersonate_auth_token", response.access_token);
          this.$store.commit("updateNotifications");
          this.$store.commit("updateGroups");
          this.$store.commit("updateModules");
          this.$store.commit("loading", { loading: false });
        },
        response => {
          console.error("[error] impersonateUser");
        }
      );
    }

  }
}
</script>
